import { useEffect } from 'react'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { routes } from '~/config/routes'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { AccessType } from '~/types'
import { accessToken } from '~/utils/access-token'

type Options = {
  redirectUrl?: string
  type?: AccessType
}

export const withUnauth = <T extends {}>(
  PageComponent: NextPage<T>,
  { type = 'dashboard' }: Options = {}
) => {
  const WithUnauth: NextPage<T> = pageProps => {
    const router = useRouter()

    useEffect(() => {
      if (accessToken.get(type)) {
        router.replace(
          type === 'dashboard'
            ? routes.dashboard.redirect
            : routes.donorPortal.home
        )
      }
    }, [])

    return <PageComponent {...pageProps} />
  }

  return hoistNonReactStatics(WithUnauth, PageComponent)
}
